const KEY = 'FEEDBACK';

export { KEY };
